import {Component} from '@angular/core';
import {NavParams, ViewController} from 'ionic-angular';
import {TreeNode} from '../../../../../content/shared/interfaces/tree-node.interface';

/**
 * Class for the AbstractTopicModalComponent
 * @class AbstractTopicModalComponent
 *
 * @description Base class for the Primary and Secondary Topic modals
 *
 * @usage
 * To be used with a [ModalController]{@link https://ionicframework.com/docs/api/components/modal/ModalController/} create call
 * ```ts
 *
 * const modal = this.modalController.create(
 *    AbstractTopicModalComponent,
 *    { choices: this.choices, value: this.value }:
 *    {
 *      choices: TreeNode[],
 *      value: TreeNode[]
 *    },
 *    {}: ModalOptions);
 * modal.onDidDismiss((data) => this.hModalDismiss(data))
 * modal.present();
 * ```
 */
@Component({
  selector: 'advtech-abstract-topic-modal',
  templateUrl: './abstract-topic-modal.component.html',
})
export class AbstractTopicModalComponent {

  /**
   * Title of the modal
   * @type {string}
   */
  title: string;

  /**
   * Topic choices
   * @type {TreeNode[]}
   */
  choices: TreeNode[];

  /**
   * Passed into the tree list to determine the type of node to create
   * @type {boolean}
   */
  multiple: boolean = false;

  /**
   * Current value of the input. Used to display the selection and emit new selections
   */
  value: TreeNode[];

  /**
   * @constructor
   * @param {ViewController} viewCtrl ViewController instance
   * @param {NavParams} navParams NavParams instance
   */
  constructor(private viewCtrl: ViewController, private navParams: NavParams) {
    this.choices = this.navParams.get('choices');
    this.value = this.navParams.get('test');
  }

  /**
   * Called from the cancel button and emits no data
   * @returns {void}
   */
  dismiss(): void {
    this.viewCtrl.dismiss();
  }

  /**
   * Called from the done button and emits the current value
   * @returns {void}
   */
  done(): void {
    this.viewCtrl.dismiss({value: this.value});
  }

  /**
   * Handles the tree node selection and updates the value
   * @param {{value: TreeNode[]}} e The selected node
   * @returns {void}
   */
  hTreeSelection(e: { value: TreeNode[] }): void {
    this.value = e.value;
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/metadata-menu/topic/abstract-topic-modal/abstract-topic-modal.component.ts